<template>
  <div v-if="showPendingInstantQuote" class="ls-pending-instant-quote-item" test-id="main_div">
    <div class="ls-pending-instant-quote-item--left">
      <div class="ls-pending-instant-quote-item--header">
        <LsIcon type="hourglass" color="primary" :size="screenSize.desktop ? 'sm' : 'xlg'" />
        <p class="ls-pending-instant-quote-item--title">
          Pending Quote for {{ instantQuote[iqType].service.name }}
        </p>
      </div>
      <div class="ls-pending-instant-quote-item--info">
        <p class="has-text-weight-bold">{{ renderQuoteString }}</p>
        <div>
          <p>
            Quote expires in
            <LsCountdownTimer
              :expires-at="instantQuote.hide_at"
              :on-countdown-end="onCountdownEnd"
            />
          </p>
        </div>
      </div>
    </div>
    <LsButton
      class="ls-pending-instant-quote-item--button"
      text="review & approve"
      bg-color="primary"
      text-color="white"
      track-id="ls_pending_instant_quote_item-review_and_approve"
      test-id="review_and_approve"
      @click="onClick()"
    />
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { lsFilters, lsModalService, lsPropTypeHelpers } from 'ls-vue-common';
import { LsButton, LsIcon, LsCountdownTimer } from '@/components/common';
import _ from 'lodash';
import { mapState } from 'vuex';
import moment from 'moment';
import { ApprovePendingInstantQuoteModal } from '@/modals';

export default {
  name: 'LsPendingInstantQuoteItem',
  components: {
    LsButton,
    LsIcon,
    LsCountdownTimer,
  },
  props: {
    instantQuote: VueTypes.shape({
      id: VueTypes.number.isRequired,
      hide_at: VueTypes.custom(lsPropTypeHelpers.stringOrNull), // YYYY-MM-DD HH:mm:ss
      type: VueTypes.string.isRequired,
      price: VueTypes.number.isRequired,
    }).isRequired.loose,
    // eslint-disable-next-line vue/prop-name-casing
    property_id: VueTypes.number.isRequired,
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
  },
  data() {
    return {
      timerExpired: false,
    };
  },
  computed: {
    ...mapState(['screenSize']),
    showPendingInstantQuote() {
      return (
        moment()
          .utc()
          .isBefore(this.instantQuote.hide_at) &&
        !_.isNil(this.instantQuote.hide_at) &&
        !this.timerExpired
      );
    },
    iqType() {
      return this.instantQuote.type;
    },
    actionText() {
      return this.instantQuote[this.iqType].copy.action;
    },
    renderQuoteString() {
      return `Quote - ${lsFilters.currency({
        amount: this.instantQuote.price,
      })} ${this.actionText}`;
    },
  },

  methods: {
    onCountdownEnd() {
      this.timerExpired = true;
    },
    onClick() {
      lsModalService.open({
        parent: this,
        component: ApprovePendingInstantQuoteModal,
        props: {
          quoteString: this.renderQuoteString,
          instantQuoteId: this.instantQuote.id,
          property_id: this.property_id,
          name: this.instantQuote[this.iqType].service.name,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-pending-instant-quote-item {
  padding: 20px;
  margin: 20px 0;
  background: $primary-light;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.ls-pending-instant-quote-item--header {
  display: flex;
  align-items: center;
  font-size: $size-4;
  padding-bottom: 6px;
}

.ls-pending-instant-quote-item--title {
  padding-left: 3px;
  color: $primary;
  font-weight: bold;
  font-size: $size-4;
}

.ls-pending-instant-quote-item--button {
  margin-left: auto;
  @media (max-width: $mobile-max-width) {
    margin-top: 20px;
  }
}

.themed-app {
  .ls-pending-instant-quote-item {
    background: $theme-color-primary-light;
  }
  .ls-pending-instant-quote-item--header {
    font-size: var(--theme-txt-body-lg);
  }
  .ls-pending-instant-quote-item--title {
    color: $theme-color-primary;
    font-size: var(--theme-txt-body-lg);
  }
}
</style>
